import React from 'react';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../ui/form/ConfigFormItem';
import { DivInputStyle } from '../../../../ui/form/DivInputStyle';
import { ComputeExpressionPreview } from '../../../expressions/compute/preview/ComputeExpressionPreview';
import { getWidgetProps } from '../inputs/common/util/getWidgetProps';
import { IComputedExpressionWidget } from './IComputedWidget';

interface ICommonComputedWidgetPreviewProps
  extends IWidgetComponentProps<IComputedExpressionWidget> {}

export function CommonComputedWidgetPreview(
  props: ICommonComputedWidgetPreviewProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <DivInputStyle>
        <ComputeExpressionPreview expression={widget.expression} />
      </DivInputStyle>
    </ConfigFormItem>
  );
}
